<template>
  <div class="entry-container">
    <div class="banner-section">
      <div class="overlay">
        <h2>나를 아끼고 가꾸는</h2>
        <h2>사람들을 위한 바버샵 플랫폼,</h2>
        <p>모두의 아름다움을 담는 마이바버샵과 함께하세요!</p>

        <div class="button-group">
          <button @click="goToInquiry">상담신청</button>
          <button @click="goToRegister">매장 등록</button>
          <button @click="goToHome">시작하기</button>
        </div>
      </div>
    </div>
  </div>
  <section class="contact-info-grid">
    <div class="info-card">
      <img src="@/assets/icon-call1.png" alt="상담" />
      <p class="title">입점/등록/운영문의</p>
      <p class="desc">010-4847-6710<br />평일, 토요일 10:00 ~ 19:00</p>
    </div>
    <div class="info-card">
      <img src="@/assets/icon-call2.png" alt="정산" />
      <p class="title">취소환불/정산문의</p>
      <p class="desc">010-4847-6710<br />평일, 토요일 10:00 ~ 19:00</p>
    </div>
    <div class="info-card">
      <img src="@/assets/icon-kakao.png" alt="카카오톡" />
      <p class="title">@마이바버샵_파트너<br />카카오톡 상담문의</p>
      <p class="desc">평일, 토요일 10:00 ~ 19:00</p>
    </div>
    <!--
    <div class="info-card">
      <img src="@/assets/icon-chat.png" alt="상담" />
      <p class="title">1:1 온라인 상담<br />원격상담 요청</p>
      <p class="desc">평일, 토요일 10:00 ~ 19:00</p>
    </div>
  -->
  </section>
  <footer class="site-footer">
    <div class="footer-highlight-box">
      (주)박씨네IT 대표자 박정인 ｜ 주소 : 충남 천안시 서북구 성정로 139-10 ｜ 사업자등록번호 : 104-15-98697 등록정보확인 ｜ 호스팅서비스사업자 : (주)박씨네IT
    </div>
    <div style="margin-top: 8px;">
      통신판매업신고번호 : 제 2025-충남천안-2082호  ｜ 이메일문의 : <a href="mailto:nickcaestro@gmail.com">contact@mrparksit.co.kr</a>
    </div>
    <div style="margin-top: 8px;">
      ※ 본 사이트는 (주)박씨네IT가 소유 및 운영하는 공식 서비스입니다.
    </div>
    <div style="margin-top: 8px;">
       <router-link to="/terms">이용약관</router-link> |
       <router-link to="/privacy-policy">개인정보처리방침</router-link>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'BarbershopEntryView',
  methods: {
  goToInquiry() {
    this.$router.push({ name: 'BarbershopInquiry' });
  },
  goToRegister() {
    const user = localStorage.getItem('user');
    if (user && user !== 'null') {
      this.$router.push('/register');
    } else {
      this.$router.push({ path: '/login', query: { redirect: '/register' } });
    }
  },
  goToDashboard() {
    const user = localStorage.getItem('user');
    if (user && user !== 'null') {
      this.$router.push('/dashboard');
    } else {
      this.$router.push({ path: '/login', query: { redirect: '/dashboard' } });
    }
  },
  goToHome() {
    const user = localStorage.getItem('user');
    if (user && user !== 'null') {
      this.$router.push('/dashboard');
    } else {
      this.$router.push({ path: '/login', query: { redirect: '/dashboard' } });
    }
  }
  }
}
</script>

<style scoped>
.entry-container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.banner-section {
  position: relative;
  width: 100%;
  height: 100vh;
  background-image: url('@/assets/partner-banner-02.png');
  background-size: cover;
  background-position: center;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4); /* 어두운 반투명 레이어 */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  padding: 0 16px;
  text-align: center;
}

.overlay h2 {
  font-size: 2.2rem;
  font-weight: bold;
  margin: 0.2rem 0;
}

.overlay p {
  font-size: 1.1rem;
  margin: 1rem 0 2rem;
}

.button-group {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  justify-content: center;
}

.button-group button {
  padding: 14px 28px;
  border-radius: 30px;
  font-size: 16px;
  background-color: transparent;
  border: 2px solid #fff;
  color: white;
  cursor: pointer;
  transition: 0.2s ease-in-out;
}

.button-group button:hover {
  background-color: white;
  color: #000;
}
.site-footer {
  background-color: #f8f8f8;
  padding: 24px;
  font-size: 13px;
  color: #666;
  text-align: center;
}

.site-footer a {
  color: #888;
  text-decoration: none;
  margin: 0 4px;
}

.contact-info-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: center;
  margin: 40px auto;
  max-width: 1000px;
}

.info-card {
  background-color: white;
  border: 1px solid #eee;
  border-radius: 16px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  padding: 28px 20px;
  text-align: center;
  width: 240px;
}

.info-card img {
  width: 48px;
  height: 48px;
  margin-bottom: 16px;
}

.info-card .title {
  font-weight: bold;
  margin-bottom: 8px;
  font-size: 16px;
}

.info-card .desc {
  font-size: 14px;
  color: #555;
  line-height: 1.6;
}
</style>

.footer-highlight-box {
  background-color: #fbd9d9;
  padding: 12px 16px;
  border-radius: 4px;
  font-size: 14px;
  color: #333;
  line-height: 1.6;
}
